import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoResponsablesItemEditarConfirmarComponent {
  proyectoId
  data
  error = false
  resultado = {exito: false}
  procesando = false
  onClose
  onChange

  constructor(ViaticosProyectoResponsable) {
    this.ViaticosProyectoResponsableService = ViaticosProyectoResponsable
  }

  $onInit() {
    console.info('estamos en Confirmar-editar', this.proyectoId)
  }

  guardar() {
    if (this.procesando) return

    this.procesando = true

    this.ViaticosProyectoResponsableService.put(this.proyectoId, this.data)
      .then((response) => (this.resultado.empresa_id = response.data, this.resultado.exito = true))
      .catch((response) => (this.error = response.data, this.procesando = false))
  }

  cerrar() {
    this.onClose()
  }

  finalizar(){
    this.onChange()
  }
}

module.component('viaticosConfiguracionProyectoResponsablesItemEditarConfirmar', {
  controller: ViaticosConfiguracionProyectoResponsablesItemEditarConfirmarComponent,
  template,
  bindings: {
    proyectoId: '<',
    data: '<',
    onChange: '&',
    onClose: '&',
  },
})






// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/item/editar/confirmar/component.js